interface Statistic {
  value: string;
  suffix?: string;
  label: string;
}

interface Statistic1Props {
  statistics?: Statistic[];
}

export const Statistic1 = ({
  statistics = [
    {
      value: '89',
      suffix: 'k',
      label: 'Porta justo integer and velna vitae auctor'
    },
    {
      value: '76',
      suffix: '%',
      label: 'Ligula magna suscipit vitae and rutrum'
    },
    {
      value: '4',
      suffix: '.93',
      label: 'Sagittis congue augue egestas an egestas'
    }
  ]
}: Statistic1Props) => {
  return (
    <div
      id="statistic-1"
      className="py--100 py-[100px] lg:max-xl:py-[80px] md:max-lg:py-[70px] statistic-section division"
    >
      <div className="container">
        {/* STATISTIC-1 WRAPPER */}
        <div className="statistic-1-wrapper">
          <div className="flex flex-wrap mx-[calc(-0.5*_1.5rem)] justify-content-md-center md:max-lg:justify-center lg:max-xl:justify-center xl:justify-center row-cols-1 row-cols-md-3">
            {statistics.map((stat, index) => (
              <div
                key={index}
                className="md:w-4/12 lg:w-4/12 xl:w-4/12 flex-[0_0_auto] w-full max-w-full px-[calc(0.5*_1.5rem)]"
              >
                <div className="wow fadeInUp">
                  <div className="statistic-block">
                    {/* Digit */}
                    <div className="statistic-block-digit !text-center xl:!w-[35%] inline-block float-left lg:max-xl:!w-[32%] md:max-lg:!w-full md:max-lg:block md:max-lg:float-none md:max-lg:!mb-[15px] sm:max-md:!mb-[12px] xsm:max-sm:!mb-[12px]">
                      <h2 className="s-46 statistic-number leading-none !font-bold tracking-[-1px] !mb-0 md:max-lg:tracking-[-0.5px] xl:!text-[2.875rem] lg:max-xl:!text-[2.625rem] md:max-lg:!text-[2.35294rem] sm:max-md:!text-[2.5rem] sm:max-md:!leading-[1.35] xsm:max-sm:!text-[2.25rem] font-Jakarta">
                        <span className="count-element">{stat.value}</span>
                        {stat.suffix && (
                          <span className="count-element">{stat.suffix}</span>
                        )}
                      </h2>
                    </div>
                    {/* Text */}
                    <div className="statistic-block-txt color--grey xl:!w-[65%] inline-block pl-[20px] lg:max-xl:!w-[68%] lg:max-xl:!pl-[10px] md:max-lg:!w-full md:max-lg:inline-block md:max-lg:!p-[0_8%] md:max-lg:!text-center">
                      <p className="p-md leading-[1.35] !mb-0">{stat.label}</p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
          {/* End row */}
        </div>
        {/* END STATISTIC-1 WRAPPER */}
      </div>
      {/* End container */}
    </div>
  );
};
